export default () => {

  const section = document.body.id;

  const pages = {
    home: import('./pages/home'),
    privacy: import('./pages/privacy'),
    terms: import('./pages/terms'),
    contact: import('./pages/contact'),
    ccpa: import('./pages/ccpa'),
  }

  async function renderPage(name) {
    const page = await pages[name]
    return page.render()
  }

  renderPage(section);
}
